import { Injectable } from "@angular/core";
import { ConsumptionOmie, IConsumptionsOmiePayload, PriceOmie } from "@edp-models/consumptions-omie.model";
import { ApiService } from "@edp-services/api.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ConsumptionsOmieService {
    constructor(private apiService: ApiService) {}

    public getWeeklyAverage() {
        return this.apiService.callServicePostToCollectionCatalog("tdmi.weeklyAverage", {});
    }

    public getConsumption(payload: IConsumptionsOmiePayload): Observable<Error | ConsumptionOmie> {
        return this.apiService.callServicePostToCollectionCatalog("tdmi.consumption", payload);
    }

    public getOmiePrice(): Observable<Error | PriceOmie> {
        return this.apiService.callServicePostToCollectionCatalog("tdmi.omieDasbhoardWidget", {});
    }
}
